/**
 * getRandomQuiz.js
 * Written by: Alex Kasemir
 */
import request from '../../../request/actions';

export const getRandomQuizStart = () => ({
  type: `GET_RANDOM_QUIZ_START`,
});

export const getRandomQuizSuccess = (id, quiz) => ({
  type: `GET_RANDOM_QUIZ_SUCCESS`,
  quiz,
  id,
});

export const getRandomQuizFailure = (error) => ({
  type: `GET_RANDOM_QUIZ_FAILURE`,
  error,
});

/**
 * Description of the getRandomQuiz action
 */
export const getRandomQuiz = () => {
  return (dispatch) => {
    dispatch(getRandomQuizStart());
    return new Promise((resolve, reject) => {
      dispatch(request(`/quizzes/?random=t`, `GET`))
        .then((response) => {
          dispatch(getRandomQuizSuccess(response.data.id, response.data));
          resolve(response.data);
        })
        .catch((error) => {
          dispatch(getRandomQuizFailure(error));
          reject();
        });
    });
  };
};

export default getRandomQuiz;
